/**
 * @generated SignedSource<<3c3536cc7a5c8436ee639e9888bc94a0>>
 * @relayHash 71bb59b25eee2b1f891c91fe9933ffc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3b82190fe4b22ef9486877f619b4cfa7f7d954da4e85ce5533f37d81ad634396

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CardCoverManagerQuery } from './CardCoverManagerQuery.graphql';

const node: PreloadableConcreteRequest<CardCoverManagerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3b82190fe4b22ef9486877f619b4cfa7f7d954da4e85ce5533f37d81ad634396",
    "metadata": {},
    "name": "CardCoverManagerQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
